import { DevelopmentalData } from "@/types/developmental";

export const age2Activities: DevelopmentalData = {
  motor: [
    "Obstacle courses",
    "Ball games (throwing, kicking)",
    "Drawing and coloring",
    "Dancing and movement games",
    "Climbing at playground"
  ],
  language: [
    "Story time with questions",
    "Simple songs and rhymes",
    "Picture naming games",
    "Follow simple directions",
    "Conversation practice"
  ],
  cognitive: [
    "Sorting games",
    "Simple puzzles",
    "Counting activities",
    "Color matching games",
    "Memory games"
  ],
  independent: [
    "Dressing practice",
    "Feeding skills",
    "Toilet training",
    "Simple cleanup tasks",
    "Hand washing routine"
  ],
  social: [
    "Group play activities",
    "Sharing exercises",
    "Turn-taking games",
    "Emotion recognition",
    "Cooperative play"
  ]
};